import React from 'react'

import { useEffect, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  InputAdornment,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Avatar,
  CircularProgress,
  Chip,
  TablePagination,
} from "@mui/material";
import { Search as SearchIcon } from "@mui/icons-material";
import { getSubscriberList } from '../../apis/apiList/stripeApi';
import { useApp } from '../../context/AppContext';
import { getPlanById } from '../../data/products';


// Dummy API
async function fetchSubscribers(user) {
  return new Promise( async(resolve) =>{
      const res = await getSubscriberList({
        headers: {
          "Content-Type": "application/json",
          "x-access-token": user.jwtToken,
        },
      });
      resolve(res.subscriptions);
    }
  );
}

export default function SubscriberList() {
  const { userDetails } = useApp();
  const [subscribers, setSubscribers] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);

  // pagination state
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  useEffect(() => {
    fetchSubscribers(userDetails).then((data) => {
      console.log('subscribers',data);
      setSubscribers(data);
      setLoading(false);
    });
  }, []);

  const filtered = subscribers.filter((s) => {
  const orgName = s?.organization?.organizationName || "";
  const email = s?.email || "";
  // const plan = s?.plan || "";

  return (
    orgName.toLowerCase().includes(search.toLowerCase()) ||
    email.toLowerCase().includes(search.toLowerCase()) 
    // ||
    // plan.toLowerCase().includes(search.toLowerCase())
  );
});

  // Paginate filtered results
  const paginated = filtered.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const getPlanNameById = (priceId) => {
    const plan = getPlanById(priceId);
    return plan ? plan.name : "Unknown Plan";
  }

  return (
    <Box sx={{ p: { xs: 2 } }}>
      <Typography variant="h4" sx={{ fontWeight: "bold", mb: 3 }}>
        Subscribers
      </Typography>

      {/* Search */}
      <TextField
        placeholder="Search by name, email"
        fullWidth
        value={search}
        onChange={(e) => {
          setSearch(e.target.value);
          setPage(0); // reset page on search
        }}
        sx={{ mb: 3 }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
        }}
      />

      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", mt: 6 }}>
          <CircularProgress />
        </Box>
      ) : filtered.length === 0 ? (
        <Typography variant="body1" color="text.secondary" sx={{ mt: 4 }}>
          No subscribers found.
        </Typography>
      ) : (
        <Paper sx={{ borderRadius: 3, boxShadow: 3 }}>
          <TableContainer>
            <Table>
              <TableHead sx={{ bgcolor: "primary.main" }}>
                <TableRow>
                  <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                    Organization
                  </TableCell>
                  <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                    Email
                  </TableCell>
                  <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                    Plan
                  </TableCell>
                  <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                    Plan Status
                  </TableCell>
                  <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                    Start Date
                  </TableCell>
                  <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                    Renewal / Expire Date
                  </TableCell>
                  <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                    Status
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {paginated.map((s) => (
                  <TableRow key={s.id} hover>
                    <TableCell>
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        {/* <Avatar sx={{ bgcolor: "secondary.main", mr: 2 }}>
                          {s.organization.organizationName.charAt(0).toUpperCase()}
                        </Avatar> */}
                        <Typography variant="body1" sx={{ fontWeight: 500 }}>
                          {s.organization.organizationName}
                        </Typography>
                      </Box>
                    </TableCell>
                    <TableCell>{s.email}</TableCell>
                    <TableCell>{getPlanNameById(s.planId)}</TableCell>
                    <TableCell>{s.status.charAt(0).toUpperCase() + s.status.slice(1)}</TableCell>
                    <TableCell>
                      {new Date(s.current_period_start).toLocaleDateString()}
                    </TableCell>
                    <TableCell>
                      {new Date(s.current_period_end).toLocaleDateString()}
                    </TableCell>
                    <TableCell>
                      <Chip
                        label={s.cancel_at_period_end ? "Canceled" : "Active"}
                        color={s.cancel_at_period_end ? "error" : "success"}
                        variant="outlined"
                        sx={{ textTransform: "capitalize" }}
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          {/* Pagination Controls */}
          <TablePagination
            component="div"
            count={filtered.length}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            rowsPerPageOptions={[5, 10, 25]}
          />
        </Paper>
      )}
    </Box>
  );
}
